<template>
  <div
    :style="`${customStyle}`"
  >
    <base-text
      v-if="labelPosition === 'top' && label" uppercase size="s"
      class="mb-1" medium
    >
      {{ label }}
    </base-text>
    <div
      ref="element"
      class="d-flex px-2 py-1 cursor-pointer selector"
      @click="toggleSelector()"
    >
      <!-- <base-text uppercase size="s" v-if="labelPosition === 'center' && label" >
        {{ label }}
      </base-text> -->
      <!-- Static selector -->

      <!-- If has selection -->
      <base-text
        v-if="selectedItem && selectedItem.name"
        nowrap
        light
        size="s"
        :style="`${selectedItem && selectedItem.color ? `color: ${selectedItem.color}` : ''}`"
      >
        {{ selectedItem.name }}
      </base-text>
      <base-text v-else uppercase size="s">
        {{ label && labelPosition === 'center' ? label : emptyLabel.trim().length ? emptyLabel : '&nbsp;' }}
      </base-text>
      <base-icon
        v-if="selector"
        class="ml-auto"
        icon="chevron-up-grey"
      />
      <base-icon
        v-else
        class="ml-auto"
        icon="chevron-down-grey"
      />
    </div>
    <div
      ref="popper"
      class="selector__dropdown"
      :style="`${customStyle}`"
    >
      <!-- DropDown selector -->
      <div>
        <div
          v-for="(item, index) in items"
          :key="`selector_item__${index}`"
          ref="items"
        >
          <div
            class="d-flex justify-content-between px-2 py-1"
            @click="subscriptionChange(item)"
          >
            <base-text
              trim
              max-width="180"
              size="s"
              :class="`cursor-pointer ${item.disabled ? 'disabled' : '' }`"
              :style="`${item.color ? `color: ${item.color}` : ''}`"
            >
              {{ item.name }}
            </base-text>
            <base-icon
              v-if="selectedItem && selectedItem.name && selectedItem.name === item.name"
              icon="colored-check"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { createPopper } from '@popperjs/core';

export default {
  name: 'BaseSelector',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      required: false,
    },
    height: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    labelPosition: {
      type: String,
      default: 'center', // 'top' | 'center'
    },
    /** Label to show when no element is selected */
    emptyLabel: {
      type: String,
      default: '--',
    },
    closeOnBlur: {
      type: Boolean,
      default: false,
    },
    scrollOptionIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      instance: null,
      selector: false,
      element: '',
      popper: '',
    };
  },
  computed: {
    customStyle() {
      let base = '';
      if (this.width) {
        base += `width: ${this.width}px; `;
      }
      if (this.height !== '') {
        base += `max-height: ${this.height}px; `;
        base += 'overflow-y: auto; ';
      }
      return base;
    },
    firstAvailableIndex() {
      if (this.items.length === 0) {
        return 0;
      }
      return this.items.findIndex((item) => !item.disabled);
    },
    selectedItem() {
      return this.value;
    },
  },
  watch: {
    selector(newval) {
      if (newval) {
        this.popper.setAttribute('data-show', '');
        this.createPoppover();
        if (this.scrollOptionIndex) {
          this.$refs.items[this.scrollOptionIndex].scrollIntoView();
        }
        if (this.firstAvailableIndex >= 0) {
          this.$refs.items[this.firstAvailableIndex].scrollIntoView();
        }
      } else {
        this.popper.removeAttribute('data-show');
        this.destroyPoppover();
      }
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.element = this.$refs.element;
      this.popper = this.$refs.popper;
    });
    if (this.closeOnBlur) {
      window.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.selector = false;
        }
      });
    }
  },
  methods: {
    closeSelector() {
      this.selector = false;
    },
    toggleSelector() {
      this.selector = !this.selector;
    },
    subscriptionChange(item) {
      if (item.disabled !== undefined && item.disabled) {
        return;
      }
      if (this.selectedItem.name !== item.name) {
        this.$emit('input', item);
      }
      this.toggleSelector();
    },
    createPoppover() {
      this.instance = createPopper(this.element, this.popper, {
        placement: 'bottom',
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        }],
      });
    },
    destroyPoppover() {
      if (this.instance) {
        this.instance.destroy();
        this.instance = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.selector {
  background: #FFFFFF;
  border: 1px solid #D4D4D4;
  border-radius: 3px;
  &__static {
    height: 32px;
  }

  &__dropdown {
    opacity: 0;
    pointer-events: none;
    background-color: #FAF9F7;
    border-radius: 2px;
    position: fixed;
    z-index: 99999;
      &[data-show] {
        opacity: 1;
        pointer-events: inherit;
      }
  }
}

.disabled {
  color: #ADADAD;

}
</style>
